export const gotcaste = [
  {
    src:
      "https://cdn.vox-cdn.com/thumbor/D5J8SxvLcqb7Ecj3Wp2SI8ueH08=/0x0:3155x2100/1220x813/filters:focal(1312x535:1816x1039):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/63869037/_20__Helen_Sloan___HBO.0.jpg",
    name: "Sansa Stark",
    house: "House Stark"
  },
  {
    src:
      "https://fsmedia.imgix.net/33/3f/c4/fb/6621/4588/a257/4abd3ac8ab25/jaime-lannister.jpeg?rect=0%2C39%2C1920%2C958&auto=format%2Ccompress&dpr=2&w=650",
    name: "Jaime Lannister ",
    house: "House Lannister"
  },
  {
    src:
      "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/c84f1ab96e310c9720530e59112c320fb1221023ce5b46a06f8f87d2def179fd-1558320464.jpg",
    name: "Jon Snow",
    house: "House Targaryen"
  },
  {
    src: "https://i.stack.imgur.com/uwi3K.jpg",
    name: "Robert Baratheon",
    house: "House Baratheon"
  },
  {
    src:
      "https://cdn1.thr.com/sites/default/files/imagecache/scale_crop_768_433/2017/08/macall_b._polay_-_hbo_photo_3-h_2017.jpg",
    name: "Theon Greyjoy",
    house: "House Greyjoy"
  },
  {
    src:
      "https://vignette.wikia.nocookie.net/antagonists/images/f/f2/D9249a0ca874c3c3b6641814d40fe87764568388_hq.jpg",
    name: "Ramsay Bolton",
    house: "House Bolton"
  },
  {
    src:
      "https://www.hbo.com/content/dam/hbodata/series/game-of-thrones/character/s5/oberyn-1920.jpg/_jcr_content/renditions/cq5dam.web.1200.675.jpeg",
    name: "Oberyn Martell",
    house: "House Martell"
  },
  {
    src:
      "https://cdn.vox-cdn.com/thumbor/JO_L5nkdb0l7S0jKHkbX8PBwgT4=/240x0:1680x1080/1200x675/filters:focal(240x0:1680x1080)/cdn.vox-cdn.com/uploads/chorus_image/image/55999463/1_hGvPUF1hS2L31ho1Az4FMQ.0.png",
    name: "Olenna Tyrell",
    house: "House Tyrell"
  },
  {
    src:
      "https://s3.r29static.com//bin/entry/17d/0,405,2990,1570/x,80/2184364/why-tobias-menzies-edmure-tully-2184364.jpg",
    name: "Edmure Tully",
    house: "House Tully"
  },
  {
    src:
      "https://cdn.vox-cdn.com/thumbor/Br9wg1PLYy1hoWKOXAawAlXoB4Y=/0x0:1275x787/1200x0/filters:focal(0x0:1275x787):no_upscale()/cdn.vox-cdn.com/uploads/chorus_asset/file/16287335/Screen_Shot_2019_05_19_at_9.01.31_PM.png",
    name: "Arya Stark ",
    house: "House Stark"
  },
  {
    src:
      "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/lena-headey-cersei-lannister-game-of-thrones-season-8-1553173898.jpg",
    name: "Cersei Lannister",
    house: "House Lannister"
  },
  {
    src:
      "https://vignette.wikia.nocookie.net/gameofthrones/images/4/4f/Daenerys_Season_8.jpg",
    name: "Daenerys Targaryen ",
    house: "House Targaryen"
  }
];
